import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { getToken } from "../lib/api";

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!getToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
